import { ProductItem } from '@snippets';

export function WishlistProduct({ handle }) {
  return <ProductItem product={{ handle }} isProductRow />;
}
